import { IPE_LopTinChiCreateRequest } from "../../model/request/lop-tin-chi/IPE_LopTinChiCreateRequest";
import { IPE_LopTinChiCreateMultipleRequest } from "../../model/request/lop-tin-chi/IPE_LopTinChiCreateMultipleRequest";
import { IPE_LopTinChiUpdateRequest } from "../../model/request/lop-tin-chi/IPE_LopTinChiUpdateRequest";
import { ILopTinChiUpdateIdLopsRequest } from "../../model/request/lop-tin-chi/ILopTinChiUpdateIdLopsRequest";
import { apiClient } from "../apiClient";

// Tạo/sửa lớp tín chỉ Giáo dục thể chất. Load danh sách + đặt buổi tái dùng xepTkbApi
// (SelectXepTKBLopTC / UpdateTKB) nên không khai báo lại ở đây.
export const peApi = {
    CreatePE: (request: IPE_LopTinChiCreateRequest) => apiClient.post(`lop-tin-chi/create-pe`, request),
    CreatePEMultiple: (request: IPE_LopTinChiCreateMultipleRequest) => apiClient.post(`lop-tin-chi/create-pe-multiple`, request),
    UpdatePE: (request: IPE_LopTinChiUpdateRequest) => apiClient.put(`lop-tin-chi/update-pe`, request),
    DeletePE: (id_lop_tc: number) => apiClient.delete(`lop-tin-chi/${id_lop_tc}`),
    DeleteMultiple: (ids: number[]) => apiClient.put(`lop-tin-chi/deletes`, { ids }),
    UpdateIdLops: (request: ILopTinChiUpdateIdLopsRequest) => apiClient.put(`lop-tin-chi/update-id-lops`, request),
};
